import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import '../../styles/AuthForm.css';
import API_BASE from '../../utils/api.js';
import notify from '../../utils/notify';

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (!token || !email) {
    return (
      <div className="auth-form">
        <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />
        <div className="auth-card">
          <h2>Invalid Reset Link</h2>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '16px' }}>
            This password reset link is missing required information. Please request a new one.
          </p>
          <Link to="/forgot-password">Request a new reset link</Link>
        </div>
      </div>
    );
  }

  async function handleResetPassword(e) {
    e.preventDefault();

    if (password !== confirmPassword) {
      notify('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, password }),
      });

      const data = await res.json();
      if (!res.ok) {
        notify(data.error || 'Password reset failed.');
        return;
      }

      notify('Password reset successful. You can now log in.');
      navigate('/');
    } catch (err) {
      console.error(err);
      notify('Something went wrong.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-form">
      <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />

      <form className="auth-card" onSubmit={handleResetPassword}>
        <h2>Reset Password</h2>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '8px' }}>
          Choose a new password for <strong>{email}</strong>.
        </p>

        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>

        <p>
          <Link to="/forgot-password">Request a new link</Link> &nbsp;·&nbsp; Back to <Link to="/">Log In</Link>
        </p>
      </form>
    </div>
  );
}

export default ResetPassword;
